module.exports = __webpack_public_path__ + "icon-navigation.svg?f3858d88297afac20ed2a8596f6be80a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-navigation.svg
// module id = 562
// module chunks = 0